import * as PIXI from 'pixi.js';
import AnimatedSprite from 'slotworks/graphics/animation/animated-sprite';
import Layers from 'slotworks/graphics/layers/layers';
import Contract from 'slotworks/utils/contract';

export default class WheelPlaque extends PIXI.Container {

    public heightInner: number = 0;

    private text: PIXI.Text;
    private border: PIXI.Sprite;
    private activeOver: PIXI.Sprite;

    private winAnim: AnimatedSprite;
    private activeAnim: AnimatedSprite;

    constructor(public num: string) {
        super();

        // portrait
        // anim-Wedge_80_Win-false
        // 80_BG_active_overlay
        // anim-Wedge_80_BG_Active-false
        // Wedge_80_BG_Static

        this.text = Layers.Bonus.getText(`Wedge_${num}_text`);
        this.border = Layers.Bonus.getSprite(`Wedge_${num}_border`) || Layers.Bonus.getSprite(`Wedge_${num}_BG_Static`);
        this.winAnim = Layers.Bonus.getAnimatedSprite(`Wedge_${num}_Win`);
        this.activeAnim = Layers.Bonus.getAnimatedSprite(`Wedge_${num}_BG_Active`);
        this.activeOver = Layers.Bonus.getSprite(`${num}_BG_active_overlay`);

        this.x = this.border.x;
        this.y = this.border.y;
        this.heightInner = this.border.height;

        const fixPosition = (el: { x: number, y: number }) => {
            el.x = el.x - this.x;
            el.y = el.y - this.y;
        }

        if(this.text)
            fixPosition(this.text);
        fixPosition(this.activeAnim);
        fixPosition(this.activeOver);
        fixPosition(this.winAnim);

        this.border.x = this.border.y = 0;

        this.addChild(this.border);
        this.addChild(this.activeAnim);
        if(this.text)
            this.addChild(this.text);
        this.addChild(this.activeOver);
        this.addChild(this.winAnim);

        this.activeAnim.visible = true;
        this.activeAnim.gotoAndStop(0);
    }

    public anticipate() {
        this.activeAnim.play();
        this.activeAnim.loop = true;
    }

    public stop() {
        this.activeAnim.stop();
        this.winAnim.stop();
        this.winAnim.visible = false;
    }

    public win(): Contract<void> {
        return new Contract<void>(resolve => {
            this.activeAnim.stop();
            this.winAnim.visible = true;
            this.winAnim.gotoAndPlay(0);
            this.winAnim.loop = true;
            resolve(null);
        });
    }

    public clean() {
        this.winAnim.stop();
        this.activeAnim.stop();
        this.removeChild(this.winAnim);
        this.removeChild(this.activeAnim);
        this.removeChild(this.activeOver);
        this.removeChild(this.text);
        this.removeChild(this.border);
        this.winAnim = null;
        this.activeAnim = null;
        this.text = null;
        this.activeOver = null;
        this.border = null;
    }

}